// Templates do WhatsApp Oficial (Meta Cloud API) no Atendimento (#28). Fora da janela de 24 horas
// da última mensagem do contato, a Meta só aceita template aprovado. O backend recusa o resto
// (409); aqui montamos o `wa_template` que o envio espera e a prévia do texto.

import { DM_WINDOW_MS } from './dmWindow.js'

export const WA_WINDOW_MS = DM_WINDOW_MS

// Conversa de WhatsApp que responde pela Cloud API (a `wa_instance_name` é o id da conta Meta).
export const isMetaWhatsAppConversation = (conv) =>
  !!conv && conv.channel === 'whatsapp' && conv.wa_provider === 'meta'

// Só template APPROVED serve para enviar; PENDING/REJECTED/PAUSED a Meta recusa.
export const approvedTemplates = (templates) =>
  (Array.isArray(templates) ? templates : []).filter((t) => t?.status === 'APPROVED')

const bodyOf = (tpl) =>
  (tpl?.components || []).find((c) => String(c.type).toUpperCase() === 'BODY') || null

export const templateBodyText = (tpl) => bodyOf(tpl)?.text || ''

// Quantas variáveis {{1}}, {{2}}... o corpo tem (o maior índice).
export function templateVariableCount(tpl) {
  let max = 0
  for (const m of templateBodyText(tpl).matchAll(/\{\{\s*(\d+)\s*\}\}/g)) max = Math.max(max, Number(m[1]))
  return max
}

// Prévia do corpo com as variáveis preenchidas; sem valor, mantém o {{n}} visível.
export function renderTemplateBody(tpl, values = []) {
  return templateBodyText(tpl).replace(/\{\{\s*(\d+)\s*\}\}/g, (whole, n) => {
    const v = (values[Number(n) - 1] || '').trim()
    return v || whole
  })
}

// Todas as variáveis precisam de valor: a Meta recusa parâmetro vazio.
export function templateReady(tpl, values = []) {
  const n = templateVariableCount(tpl)
  for (let i = 0; i < n; i += 1) if (!(values[i] || '').trim()) return false
  return !!tpl
}

// Objeto `wa_template` do POST /atendimento/messages.
export function buildWaTemplate(tpl, values = []) {
  const n = templateVariableCount(tpl)
  const out = { name: tpl.name, language: tpl.language || 'pt_BR' }
  if (n > 0) {
    out.components = [{
      type: 'body',
      parameters: Array.from({ length: n }, (_, i) => ({ type: 'text', text: (values[i] || '').trim() })),
    }]
  }
  return out
}
